import React from 'react'
import styles from './ConfigModal.module.scss'
import CommonToolTip from 'components/ui/tooltip/commonToolTip'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons'
import RichTextInput from 'components/ui/forms/field/rich-text-input/RichTextInput'

import { useTranslationRankmi } from 'helpers/translations.helper'
import { prefix } from '../../common'

interface TextProps {
  value: string
  onChange: (value: string) => void
}

const joditConfig = {
  buttons: 'bold,italic,underline,strikethrough,|,image,link',
}

export function Text({ value, onChange }: TextProps) {
  const t = useTranslationRankmi({
    prefix: `${prefix}.config.custom`,
  })

  return (
    <div className={styles.text}>
      <RichTextInput
        name="description"
        value={value}
        label={
          <>
            {t('label')}
            <CommonToolTip
              text={t('tooltip')}
              position="right"
              className={styles.tabsTooltip}
            >
              <FontAwesomeIcon
                icon={faInfoCircle}
                className={`ml-2 ${styles.infoIcon}`}
              />
            </CommonToolTip>
          </>
        }
        onChange={onChange}
        config={joditConfig}
      />
    </div>
  )
}
